/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import IdCardScreen from '../components/idcardscreen'
import { useAuthContext } from '../context/auth.context'
import { useLoadAwsFile } from '../hooks/asset.hooks'
import { loadAwsFile } from '../utils/aws.util'
import { useOrganizationContext } from '../context/organization.context'
import {useGetIdcardDetails} from '../hooks/asset.hooks'

const IdCardScreenPage = () => {
  
  const {
    state: { authData },
  } = useAuthContext()

  const {
    state: { orgsColor },
  } = useOrganizationContext()

  const [orgLogo, setOrgLogo] = useState(null)
  const [profileImageData, setProfileImageData] = useState(null)
  const [IdcardDetails, setIdcardDetails]= useState({})
  const [activityInlineData, setActivityInlineData] = useState({})

  const {
    operating_asset_id,
    organization_id,
    asset_image_path,
    organization_image_path
  } = authData

  const {
    employee_first_name,
    employee_organization,
    employee_designation,
  } = activityInlineData
  const {account_name} = IdcardDetails

  const { mutate, isLoading:isLoadingAWS } = useLoadAwsFile()
  const {mutate: getIdcard, isLoading}= useGetIdcardDetails()

  const cbFunc=(res) => {
    let data = 'data:' + res.type + ';base64,' + res.data
    setProfileImageData(data)
  }

  useEffect(() => {
    if (!!asset_image_path) {
        setTimeout(() => {
          mutate(
            {
              fileUrl: asset_image_path,
              cb: cbFunc,
            },
            {
              onSuccess: async res => {
                if (res) {
                  const {
                    data: { status, response },
                  } = res
  
                  if (status === 200) {
                    cbFunc(response)
                  }
                }
              },
            }
          )
        }, 1000)
      }

  if (!!organization_image_path) {
    setTimeout(() => {
      loadAwsFile(organization_image_path, d => {
        let data = 'data:' + d.type + ';base64,' + d.data
        setOrgLogo(data)
      })
    }, 1000)
  }
  if (!!operating_asset_id && !!organization_id) {
      getIdcard(
        {
          target_asset_id:operating_asset_id,
          organization_id:organization_id
        },
        {
          onSuccess: async res => {
            if (res) {
              const {
                data: { status, response },
              } = res

              if (status === 200) {
                setIdcardDetails(response[0])  
                setActivityInlineData(response[0].activity_inline_data)              
              }
            }
          },
        }
      )
  }
  }, [])

  useEffect(() => {
    if (!!asset_image_path) {
        setTimeout(() => {
          mutate(
            {
              fileUrl: asset_image_path,
              cb: cbFunc,
            },
            {
              onSuccess: async res => {
                if (res) {
                  const {
                    data: { status, response },
                  } = res
  
                  if (status === 200) {
                    cbFunc(response)
                  }
                }
              },
            }
          )
        }, 1000)
      }

  if (!!organization_image_path) {
    setTimeout(() => {
      loadAwsFile(organization_image_path, d => {
        let data = 'data:' + d.type + ';base64,' + d.data
        setOrgLogo(data)
      })
    }, 1000)
  }

  if (!!operating_asset_id && !!organization_id) {
      getIdcard(
        {
          target_asset_id:operating_asset_id,
          organization_id:organization_id
        },
        {
          onSuccess: async res => {
            if (res) {
              const {
                data: { status, response },
              } = res

              if (status === 200) {
                setIdcardDetails(response[0])
                setActivityInlineData(response[0].activity_inline_data)                
              }
            }
          },
        }
      )
  }
  
  }, [authData])

  return (
    <>
        <IdCardScreen
            employee_first_name={employee_first_name}
            employee_organization={employee_organization}
            employee_designation={employee_designation}
            account_name={account_name}
            orgColor={orgsColor[organization_id]}
            profilePic={profileImageData}
            orgPic={orgLogo}
        />
    </>
  )
}

export default IdCardScreenPage
